import { useMemo } from 'react';

import config from '@/config';
import useQuery from '@/hooks/useQuery';
import Text from '@/shared-components/text/components/Text';

import VirtualList from './components/VirtualList.jsx';
import { createUserSearchQuery, USER_SEARCH_TYPE } from './searchConfig';

import './index.css';

export default function HomeUsers({ valueFromSearch = {} }) {
  const query = useMemo(
    () => createUserSearchQuery(valueFromSearch?.q),
    [valueFromSearch?.q]
  );
  const searchLimited = query.q.length === 0;
  const { loading, queryData, loadMoreData } = useQuery("search_users", `${config.apis.api.url}/search/${USER_SEARCH_TYPE}`, query, {
    optionalToken: true
  });

  return (
    <>
      {
        !loading && (
          queryData.data.data.length === 0 ?
            <Text className="search-view-users__empty-text font-size-medium" paragraph>
              No users available for your search query.
            </Text>
            :
            <VirtualList 
              key={queryData.queryString} 
              items={queryData.data} 
              onLoadMore={loadMoreData}
              searchLimited={searchLimited}
            />
        )
      }
    </>
  );
}
